// Service area zip codes
// Port from v1 - revisit list as needed
// Manhattan, Queens, Nassau, Suffolk

export const SERVICE_AREA_ZIPS = new Set([
  // ============================================
  // MANHATTAN (10001-10282)
  // ============================================
  '10001', '10002', '10003', '10004', '10005', '10006', '10007', '10009',
  '10010', '10011', '10012', '10013', '10014', '10016', '10017', '10018',
  '10019', '10020', '10021', '10022', '10023', '10024', '10025', '10026',
  '10027', '10028', '10029', '10030', '10031', '10032', '10033', '10034',
  '10035', '10036', '10037', '10038', '10039', '10040', '10044', '10065',
  '10069', '10075', '10128', '10280', '10282',

  // ============================================
  // QUEENS (11004-11697)
  // ============================================
  '11004', '11005', '11101', '11102', '11103', '11104', '11105', '11106',
  '11109', '11354', '11355', '11356', '11357', '11358', '11359', '11360',
  '11361', '11362', '11363', '11364', '11365', '11366', '11367', '11368',
  '11369', '11370', '11371', '11372', '11373', '11374', '11375', '11377',
  '11378', '11379', '11385', '11411', '11412', '11413', '11414', '11415',
  '11416', '11417', '11418', '11419', '11420', '11421', '11422', '11423',
  '11426', '11427', '11428', '11429', '11432', '11433', '11434', '11435',
  '11436', '11691', '11692', '11693', '11694', '11697',

  // ============================================
  // NASSAU COUNTY
  // ============================================
  '11001', '11003', '11010', '11020', '11021', '11022', '11023', '11024',
  '11030', '11040', '11042', '11050', '11096', '11501', '11507', '11509',
  '11510', '11514', '11516', '11518', '11520', '11530', '11531', '11542',
  '11545', '11547', '11548', '11550', '11552', '11553', '11554', '11556',
  '11557', '11558', '11559', '11560', '11561', '11563', '11565', '11566',
  '11568', '11569', '11570', '11572', '11576', '11577', '11579', '11580',
  '11581', '11590', '11596', '11598',

  // ============================================
  // SUFFOLK COUNTY
  // ============================================
  '11701', '11702', '11703', '11704', '11705', '11706', '11713', '11715',
  '11716', '11717', '11718', '11719', '11720', '11721', '11722', '11724',
  '11725', '11726', '11727', '11729', '11730', '11731', '11732', '11733',
  '11738', '11739', '11740', '11741', '11742', '11743', '11746', '11747',
  '11749', '11751', '11752', '11754', '11755', '11757', '11758', '11760',
  '11762', '11763', '11764', '11765', '11766', '11767', '11768', '11769',
  '11770', '11772', '11776', '11777', '11778', '11779', '11780', '11782',
  '11784', '11786', '11787', '11788', '11789', '11790', '11792', '11794',
  '11795', '11796', '11798', '11901', '11930', '11931', '11932', '11933',
  '11934', '11935', '11937', '11939', '11940', '11941', '11942', '11944',
  '11946', '11947', '11948', '11949', '11950', '11951', '11952', '11953',
  '11954', '11955', '11956', '11957', '11958', '11959', '11960', '11961',
  '11962', '11963', '11964', '11965', '11967', '11968', '11969', '11970',
  '11971', '11972', '11973', '11975', '11976', '11977', '11978', '11980',
]);

// Coming soon - shown as such in marketing but not in service area
export const COMING_SOON_ZIPS = new Set([
  // Westchester (selection)
  '10601', '10605', '10606', '10707', '10708',
  // Greenwich, CT
  '06830', '06831', '06870', '06878',
]);

export function isInServiceArea(zip) {
  if (!zip) return false;
  return SERVICE_AREA_ZIPS.has(String(zip).trim());
}

export function isComingSoon(zip) {
  if (!zip) return false;
  return COMING_SOON_ZIPS.has(String(zip).trim());
}
